import { Box } from '@mantine/core';
import type { ImageRef } from '@/api/types';
import { imageUrl } from '@/lib/image';

const PASTELS = ['#d9edf8', '#ffd7a6', '#dedaf3', '#c0edad', '#ffefa1', '#ffc2e8', '#ffaead'];

function pastelFor(title: string) {
  let h = 0;
  for (const c of title) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return PASTELS[h % PASTELS.length];
}

/** Artwork in an ink-outlined frame, or the pastel title placeholder when missing. */
export function Artwork({
  image,
  title,
  width,
  ratio,
  radius = 14,
  alt,
}: {
  image: ImageRef | null | undefined;
  title: string;
  width: number | string;
  ratio: number;
  radius?: number;
  alt?: string;
}) {
  const w = typeof width === 'number' ? width : 480;
  const src = imageUrl(image, Math.round(w * 2), Math.round((w * 2) / ratio));
  return (
    <Box
      className={src ? 'pb-art' : 'pb-art pb-art--placeholder'}
      style={{
        width,
        aspectRatio: String(ratio),
        borderRadius: radius,
        background: src ? undefined : pastelFor(title),
      }}
    >
      {src ? (
        <img src={src} alt={alt ?? ''} loading="lazy" />
      ) : (
        <span
          style={{ fontSize: typeof width === 'number' && width < 80 ? 9 : 14, lineHeight: 1.1 }}
          aria-hidden
        >
          {title}
        </span>
      )}
    </Box>
  );
}
